import React from "react";
import Icon from "@ant-design/icons";

const VideoSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <g>
      <path
        fill="currentColor"
        d="M4.327 11.936H9.61c1.085 0 1.708-.608 1.708-1.672V5.332c0-1.065-.583-1.673-1.668-1.673H4.327c-1.045 0-1.708.608-1.708 1.673v4.967c0 1.06.628 1.637 1.708 1.637zm7.73-2.521l1.717 1.476c.206.181.427.297.638.297.406 0 .683-.292.683-.734V5.166c0-.442-.277-.733-.683-.733-.216 0-.432.115-.638.296l-1.718 1.476v3.21z"
      ></path>
    </g>
  </svg>
);

const VideoIcon = (props) => <Icon component={VideoSvg} {...props} />;

const Videov3Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="13"
    fill="none"
    viewBox="0 0 11 13"
  >
    <path
      d="M3 11L0.5 12.5V0.5L10.5 6.5L5.5 9.5L4.875 9.875"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

const Videov3Icon = (props) => <Icon component={Videov3Svg} {...props} />;

export { VideoIcon, Videov3Icon };
